/** 消息类型 */
enum MessageType {
    文件 = 'file',
    消息 = 'message',
    任务 = 'task',
    协作 = 'cooperate',
}

export default MessageType;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/constant/MessageType/index.ts